import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr1009',
    ecrans: ['00-2'],
    params: ['id','?demcleint', 'stamnetabref', 'avicleintref']
});
